// import { action } from "typesafe-actions";
import { message } from 'antd';
import { take, call, put, fork } from 'redux-saga/effects';
import { go } from 'connected-react-router';
import { signin } from 'utils/apollo';
import * as qs from 'utils/queryString';

import { setPreviousLoginEmail, signin as signinActions } from './actions';
import ActionTypes from './constants';

function* signinFlow() {
  while (true) {
    const { payload } = yield take(ActionTypes.SIGNIN_SUBMIT);
    yield put(signinActions.request());
    const response = yield call(signin, payload);
    if (!response.errors) {
      localStorage.setItem('token', response.token);
      localStorage.setItem('rememberToken', response.rememberMeToken);
      localStorage.setItem('previousLoginEmail', payload.email);
      localStorage.setItem('rememberMe', String(payload.rememberMe ?? true));
      // @ts-ignore
      yield put(signinActions.success());
      yield put(go(qs.parse(location.search).redirect || '/'));
    } else {
      yield put(signinActions.failure(response.errors));
      response.errors.map((e: any) => message.error(e.message));
    }
  }
}

// Individual exports for testing
export default function* signinPageSaga() {
  // See example in containers/HomePage/saga.js
  yield fork(signinFlow);

  const previousLoginEmail = window.localStorage.getItem('previousLoginEmail');
  if (previousLoginEmail) {
    yield put(setPreviousLoginEmail(previousLoginEmail));
  }
}
